import React from 'react';
import saltyOrange from '../assets/logos/salty-logo-orange.svg';
import saltyBlack from '../assets/logos/salty-logo-black.svg';
import saltyCream from '../assets/logos/salty-logo-cream.svg';

type LogoVariant = 'orange' | 'black' | 'cream' | 'auto';

interface LogoMarkProps {
  /** Visual variant. 'auto' picks orange in light mode, cream in dark mode. */
  variant?: LogoVariant;
  height?: number;
  className?: string;
  /** If true, renders just the cat favicon mark instead of the wordmark */
  markOnly?: boolean;
}

export const LogoMark: React.FC<LogoMarkProps> = ({
  variant = 'auto',
  height = 28,
  className = '',
}) => {
  const src =
    variant === 'orange' ? saltyOrange :
    variant === 'black'  ? saltyBlack  :
    variant === 'cream'  ? saltyCream  :
    saltyOrange; // 'auto' — orange works on both light bg; dark bg uses CSS filter below

  return (
    <img
      src={src}
      alt="Salty"
      height={height}
      style={{ height, width: 'auto', display: 'block' }}
      className={`${variant === 'auto' ? 'dark:brightness-0 dark:invert' : ''} ${className}`}
      draggable={false}
    />
  );
};

export default LogoMark;
